export class SecurityIgnoredIssue {

  public id: string;
  public type: string;
  public fileName: string;
  public file_path: string;
  public status: string;
  public createDate: Date;
  public updateDate: Date;
  public selected: boolean;

}
